import { effect, inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorStore } from '@shared/stores/error.store';
import { ErrorNotificationModalComponent } from '@shared/components/organisms/error-notification-modal/error-notification-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { DialogComponent } from '@shared/components/organisms/dialog/dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ErrorModalService {
  private dialog = inject(MatDialog);
  private errorStore = inject(ErrorStore);

  private dialogOpen = false;

  constructor(private translate: TranslateService) {
    // In ErrorModalService constructor
    effect(() => {
      const count = this.errorStore.errorCount();
      if (count > 0 && !this.dialogOpen) {
        this.showErrorModal();
      }
    });

    this.translate.onLangChange.subscribe(() => {
      this.errorStore.retranslateMessages();
    });
  }

  showErrorModal(closeAction: (() => void) | undefined = undefined): void {
    if (this.dialogOpen) {
      return; // Prevent multiple dialogs
    }

    // Close any existing dialogs before opening a new one
    // Not sure if we want this to always close dialogs.  
    // Searching for a provision and loading one with a missing image will close the search.
    // Low priority to enhance this by introducing a variable or property to allow a dialog to stay open with an error.
    //this.dialog.closeAll();

    const errorData =
      this.errorStore.errors().concat(this.errorStore.warnings());

    const dialogRef = this.dialog.open(DialogComponent, {
      width: '500px',
      data: {
        title: 'Generic_ErrorMessage',
        icon: 'warning_amber',
        hideClose: !!closeAction,
        content: ErrorNotificationModalComponent,
        dataForComponent: errorData,
        actions: [
          {
            id: 'close',
            label: 'Generic_Close',
            styleType: 'contained',
            color: 'accent',
            onClick: (): void => {
              if (closeAction) {
                closeAction();
              }
              dialogRef.close(null);
            },
          },
        ],
      },
    });

    this.dialogOpen = true;

    dialogRef.afterClosed().subscribe(() => {
      this.dialogOpen = false;
      this.errorStore.clearErrors();
    });
  }
}
